import _regeneratorRuntime from "/home/runner/work/mycarebase/mycarebase/front-end/react-native-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/mycarebase/mycarebase/front-end/react-native-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export default
/*#__PURE__*/
(function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(endpoint) {
    var response, ip;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(endpoint || 'https://api.ipify.org');

          case 3:
            response = _context.sent;
            ip = response.text();
            return _context.abrupt("return", ip);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            throw 'Unable to get IP address.';

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();